<div class="min-h-screen flex items-center justify-center px-4 py-8">
  <div class="w-full max-w-md">
    <app-currency-input
      [label]="'Enter Amount'"
      [description]="'Leave this empty, then leave the field to see the error'"
      [placeholder]="'0.00'"
      [required]="true"
    ></app-currency-input>
  </div>
</div>
